<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <!-- <breadcrumb></breadcrumb> -->

    <div class="right-menu">
        <el-button class="btn-toshop" type="primary" @click="toAdminShop">Shop Admin</el-button>
      <template>
          <langSelect class="right-menu-item hover-effect" />
      </template>
    </div>

    <div class="router-list">
      <!-- <span v-for="(item,index) in routes.filter(item=>!item.hidden)" :key="index" @click="SET_ROUTER_NAME(item.name)" :class="{'current': item.name == routerName}">
        {{generateTitle(item.meta.title)}}
      </span> -->
    </div>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatarSrc">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            {{name}}
          </el-dropdown-item>
          <el-dropdown-item>
            {{ $t('home.home') }}
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">{{ $t('others.signOut') }}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import LangSelect from '@/components/LangSelect'
import { generateTitle } from '@/utils/i18n'
import ADMIN_SHOP_URL from '@/utils/admin-shop-url'
import avatarImg from "../../../assets/images/avatar.png"

export default {
  components: {
    Breadcrumb,
    Hamburger,
    LangSelect
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'routers',
      'routerName',
      'LangSelect',
      'name'
    ]),
    avatarSrc(){
      return this.avatar || avatarImg
    },
    routes() {
      // return this.$router.options.routes
      return this.routers.filter(item=>(item.children&&item.children.length > 1)|| item.redirect == '/home')
    },
  },
  created(){
    let routerName = ''
    this.routers.forEach(item=>{
      if(item.children && item.children.length){
        item.children.forEach(child=>{
          if(child.name == this.$route.name){
            routerName = item.name
          }
        })
      }
    })
    this.SET_ROUTER_NAME(routerName)
  },
  methods: {
    generateTitle,
    ...mapMutations(['SET_ROUTER_NAME']),
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    toAdminShop(){
      window.open(ADMIN_SHOP_URL, '_blank');
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .router-list {
    span {
      display: inline-block;
      font-size: 14px;
      padding: 0 20px;
      text-align: center;
      position: relative;
      cursor: pointer;
      color: #bbbbbb
    }
    .current {
      color: rgb(36, 210, 171);
      font-weight: 600
    }
    .current:after {
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 3px;
      background-color: rgb(36, 210, 171);
      content: ''

    }
  }
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    top: 0;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 36px;
        height: 36px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 15px;
        font-size: 12px;
      }
    }
  }
  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    margin-right: 80px;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }
  }
}
.right-menu{
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.btn-toshop{
  margin-right: 10px;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue